(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-chosen"] = factory();
	else
		root["vue-chosen"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _directive = __webpack_require__(1);
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Vue.directive('chosen', _directive2.default);

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paramWatchers;
	
	var _lang = __webpack_require__(2);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var V_MODEL = 'vModel';
	var V_ON_CHANGE = 'vOn:change';
	var DISABLED = 'disabled';
	var OPTIONS = 'options';
	var OPTION_VALUE = 'optionValue';
	var OPTION_TEXT = 'optionText';
	var TRANSFORM_VIEW = 'transformView';
	
	function getter(key, object) {
	  return object[key];
	}
	
	exports.default = {
	  params: [V_MODEL, V_ON_CHANGE, DISABLED, OPTIONS, OPTION_VALUE, OPTION_TEXT, TRANSFORM_VIEW],
	  paramWatchers: (_paramWatchers = {}, _defineProperty(_paramWatchers, DISABLED, function () {
	    Vue.nextTick(this.onChangeVm);
	  }), _defineProperty(_paramWatchers, OPTIONS, function () {
	    Vue.nextTick(this.onChangeVm);
	  }), _paramWatchers),
	  bind: function bind() {
	    // TODO: to update when the option.disabled has been updated
	    this.transformViewFn = TRANSFORM_VIEW in this.params ? this.params[TRANSFORM_VIEW] : Number;
	    this.onChangeVm = this.onChangeVm.bind(this);
	    this.onChangejQuery = this.onChangejQuery.bind(this);
	    this.initAsync = this.initAsync.bind(this);
	    Vue.nextTick(this.initAsync);
	  },
	  unbind: function unbind() {
	    this.$element.off('change', this.onChangejQuery);
	    this.$element.chosen('destroy');
	    this.unwatchModel();
	  },
	  initAsync: function initAsync() {
	    this.$element = jQuery(this.el);
	    this.updateHtml();
	    var config = this.vm.$eval(this.expression);
	    this.$element.chosen(config);
	    this.$element.on('change', this.onChangejQuery);
	    this.onChangeCallback = this.getCallback(V_ON_CHANGE);
	    this.unwatchModel = V_MODEL in this.params ? this.vm.$watch(this.params[V_MODEL], this.onChangeVm) : _lang.noop;
	  },
	  onChangejQuery: function onChangejQuery() {
	    var value = this.$element.val();
	    var isMultiple = this.isMultiple();
	    var valueAsArray = (0, _lang.isArray)(value) ? value : [value];
	    var transformedValue = isMultiple ? valueAsArray.map(this.transformViewFn) : this.transformViewFn(value);
	    if (V_MODEL in this.params) {
	      this.vm.$set(this.params[V_MODEL], transformedValue);
	    }
	    this.onChangeCallback();
	  },
	  onChangeVm: function onChangeVm() {
	    this.updateHtml();
	    this.$element.trigger('chosen:updated');
	  },
	  updateHtml: function updateHtml() {
	    if (!(OPTIONS in this.params)) {
	      return;
	    }
	    var getText = OPTION_TEXT in this.params ? getter.bind(this, this.params[OPTION_TEXT]) : _lang.identity;
	    var getValue = OPTION_VALUE in this.params ? getter.bind(this, this.params[OPTION_VALUE]) : _lang.identity;
	    var isMultiple = this.isMultiple();
	    var selectedValue = V_MODEL in this.params ? this.vm.$get(this.params[V_MODEL])
	    //  for single: NaN (because NaN !== NaN), for multiple: []
	    : this.getDefaultSelectedValue(isMultiple);
	    var array = this.params[OPTIONS];
	    var fragment = document.createDocumentFragment();
	    // Fix for showing of a placeholder http://stackoverflow.com/a/11649777
	    fragment.appendChild(new Option());
	    for (var i = 0; i < array.length; i++) {
	      var item = array[i];
	      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLOptionElement/Option
	      var text = getText(item);
	      var value = getValue(item);
	      var isSelectedValue = this.isSelectedValue(isMultiple, selectedValue, value);
	      var option = new Option(text, value, isSelectedValue, isSelectedValue);
	      fragment.appendChild(option);
	    }
	    this.$element.empty();
	    this.$element.append(fragment);
	  },
	  getCallback: function getCallback(key) {
	    if (!(key in this.params)) {
	      return _lang.noop;
	    }
	    var path = this.params[key];
	    var pathFn = path.replace(/\(\)$/, '');
	    var pathCtx = path.slice(0, path.lastIndexOf('.'));
	    var fn = this.vm.$get(pathFn);
	    var ctx = this.vm.$get(pathCtx) || this.vm;
	    return fn ? fn.bind(ctx) : _lang.noop;
	  },
	
	  /**
	   * @param {Boolean} isMultiple
	   * @returns {Array|Number}
	   */
	  getDefaultSelectedValue: function getDefaultSelectedValue(isMultiple) {
	    return isMultiple ? [] : NaN;
	  },
	
	  /**
	   * @param {Boolean} isMultiple
	   * @param {Array|String|Number} selectedValue
	   * @param {String|Number} anyValue
	   * @returns {Boolean}
	   */
	  isSelectedValue: function isSelectedValue(isMultiple, selectedValue, anyValue) {
	    return isMultiple ? selectedValue.indexOf(anyValue) !== -1 : selectedValue === anyValue;
	  },
	
	  /**
	   * @returns {Boolean}
	   */
	  isMultiple: function isMultiple() {
	    return Boolean(this.$element.attr('multiple'));
	  }
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * @param {*} argument
	 * @returns {*}
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.identity = identity;
	exports.noop = noop;
	function identity(argument) {
	  return argument;
	}
	/**
	 * @returns {Boolean}
	 */
	var isArray = Array.isArray;
	/**
	 *
	 */
	
	exports.isArray = isArray;
	function noop() {}

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// vue-chosen.min.js